import { useTranslation } from "react-i18next";

export default function StatsSection() {
  const { t } = useTranslation();

  const stats = [
    { label: t("stats.works", "覆盖作品"), value: "10,000+", suffix: "部" },
    { label: t("stats.users", "全球用户"), value: "500", suffix: "万+" },
    { label: t("stats.daily", "日更新量"), value: "200+", suffix: "话" },
    { label: t("stats.languages", "支持语言"), value: "15", suffix: "种" },
  ];

  return (
    <section className="px-4 md:px-6 py-14 md:py-20">
      <div className="max-w-5xl mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12">
          {stats.map((stat) => (
            <div key={stat.label} className="text-center">
              <p className="text-3xl md:text-5xl font-bold text-foreground-950 tracking-tight">
                {stat.value}
                <span className="text-lg md:text-xl font-normal text-foreground-500 ml-1">
                  {stat.suffix}
                </span>
              </p>
              <p className="mt-2 text-sm text-foreground-500">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}